<div class="fill" [style.width]="(percentage | min:0 | max:100) + '%'" [style.background]="color"></div>